// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3nX4S","dragIcon":"Choice_dragIcon__3eZJU","left":"Choice_left__tEJ8M","input":"Choice_input__1bX0L"};